export default function (scopeSelector) {
    

    const $carousel = $('.ob-image-main-carousel:not(.slick-initialized)', scopeSelector);

    $carousel.slick({
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        lazyLoad: 'anticipated',
        asNavFor: `${scopeSelector} .ob-image-carousel-nav .mini-nav`,
        infinite: false,
        useTransform: false,
    });
}
